import React, { useState } from 'react';
import useTranslationLgs from '@hooks/i18n/useTranslation';
import { Button } from 'primereact/button';
import styled from 'styled-components';
import { isNullOrUndefined } from '@utils/utils';
import { dayjsFromApiUtc, formatDateTimeFromDayjsInTzWithLocale } from '@utils/dateWithTz.tsx';
import ConfirmDialog from '@components/RingilComponents/ConfirmDialog.tsx';
import COTimezone from '@components/FigmaComponents/COTimezone.tsx';

interface ComponentProps {
  onReconfirm: () => void;
  reconfirmedAtUtc?: string;
  timezoneId?: string;
  isReconfirmedByCarrier?: boolean;
  disabled: boolean;
}

const ReconfirmQuote: React.FC<ComponentProps> = ({ onReconfirm, reconfirmedAtUtc, timezoneId, isReconfirmedByCarrier, disabled }) => {
  const { tr } = useTranslationLgs();
  const [visibleDialog, setVisibleDialog] = useState(false);

  return (
    <>
      <Row>
        <div>{tr(`ReconfirmQuote.reconfirmationNeededTitle`, `Zákazník požádal o opětovné potvrzení nabídky`)}</div>
        <Button
          type="button"
          label="?"
          tooltip={tr(
            `ReconfirmQuote.reconfirmationTooltip`,
            `Zákazník žádá o potvrzení přijetí přepravy, aby měl jistotu, že s přepravou počítáte a nemusel Vás kontaktovat telefonicky. Pokud přepravu nemůžete potvrdit, kontaktujte, prosím, zákazníka.`,
          )}
          className="p-button-text p-ml-2 p-mb-2 p-mb-2"
          tooltipOptions={{ position: 'top' }}
        />
      </Row>
      {isNullOrUndefined(reconfirmedAtUtc) && (
        <Row>
          <Button
            type="button"
            label={tr(`ReconfirmQuote.reconfirmButton`, `Potvrdit přijetí`)}
            className="p-button-rounded"
            onClick={e => setVisibleDialog(true)}
            disabled={disabled}
          />
        </Row>
      )}

      {isReconfirmedByCarrier && (
          <>
            <div>
              {tr(
                `ReconfirmQuote.carrierReconfirmedAtEscaped`,
                `Dopravce potvrdil přijetí přepravy {{-when}}`,
                {
                  when: formatDateTimeFromDayjsInTzWithLocale(dayjsFromApiUtc(reconfirmedAtUtc), timezoneId),
                },
              )}
            </div>
            <COTimezone timezoneId={timezoneId} />
          </>
        )}
        {!isReconfirmedByCarrier && !isNullOrUndefined(reconfirmedAtUtc) && !isNullOrUndefined(timezoneId) && (
          <>
            <div>
              {tr(
                `ReconfirmQuote.customerReconfirmedAtEscaped`,
                `Zákazník potvrdil za dopravce {{-when}}`,
                {
                  when: formatDateTimeFromDayjsInTzWithLocale(dayjsFromApiUtc(reconfirmedAtUtc), timezoneId),
                },
              )}
            </div>
            <COTimezone timezoneId={timezoneId} />
          </>
        )}

      <ConfirmDialog
        visible={visibleDialog}
        dialogTitle={tr(`ReconfirmQuote.reconfirmDialogTitle`, `Potvrzení přijetí přepravy`)}
        dialogMessage={tr(`ReconfirmQuote.reconfirmDialogBody`, `Potvrzujeme, že s přepravou počítáme a budeme ji realizovat.`)}
        onConfirm={() => {
          onReconfirm();
          setVisibleDialog(false);
        }}
        onCancel={() => setVisibleDialog(false)}
        onAcceptButtonText={tr(`ReconfirmQuote.accept`, `Potvrdit`)}
        onCancelButtonText={tr(`ReconfirmQuote.back`, `Zpět`)}
      ></ConfirmDialog>
    </>
  );
};

const Row = styled.div`
  display: flex;
  align-items: center;
`;

export default ReconfirmQuote;
